import { Dayts, DaytsFormatEnum, replaceTokens } from '@/utils';

import { Trip } from '@/models/gen/graphql';

// Builds the placeholder -> value map used to auto-fill quick-reply templates from a room's trip.
// Every value is a string; missing fields resolve to '' so the placeholder is left for manual entry.
export const getTripTokens = (trip: Trip | null): Record<string, string> => {
  if (!trip) return {};
  const minutesUntilPickup = trip.scheduled ? new Dayts(trip.scheduled).diff(new Dayts(), 'minute', true) : NaN;
  return {
    van: trip.vehicle?.trackingId ? `Van ${trip.vehicle.trackingId}` : '',
    // Replaces a template's "··· <instruction>" suffix; only filled when pickup is within the hour.
    vanfollowup: minutesUntilPickup >= 0 && minutesUntilPickup <= 60 ? '<Van> to follow shortly.' : '',
    vehicle: trip.vehicle?.trackingId || '',
    pickup: trip.puLocation?.name || '',
    pickuplocation: trip.puLocation?.name || '',
    dropoff: trip.doLocation?.name || '',
    eta: `${trip.etaMinutes ?? ''}` || '',
    flightnumber: `${trip?.loopName || trip?.flightNumber || ''}`,
    FlightNumber: `${trip?.loopName || trip?.flightNumber || ''}`,
    crew: `${trip?.payerProvider?.displayName} Crew`,
    driver: trip.driver?.fullName || '',
    pickuptime: trip.scheduled ? new Dayts(trip.scheduled).format(DaytsFormatEnum.TIME) : '',
    pickup_time: trip.scheduled ? new Dayts(trip.scheduled).format(DaytsFormatEnum.TIME) : '',
  };
};

// Marks the start of a trailing "··· append ..." instruction some templates carry for the dispatcher.
const FOLLOW_UP_INSTRUCTION_MARKER = '···';

const replaceFollowUpInstruction = (message: string, followUp: string): string => {
  if (!message.includes(FOLLOW_UP_INSTRUCTION_MARKER)) return message;
  const [confirmation] = message.split(FOLLOW_UP_INSTRUCTION_MARKER);
  return followUp ? `${confirmation.trimEnd()} ${followUp}` : confirmation.trimEnd();
};

export const fillQuickReplyTripTokens = (message: string, tokens: Record<string, string>): string =>
  replaceTokens(
    replaceFollowUpInstruction(message, tokens.vanfollowup),
    (token: string) => tokens[token.toLowerCase()] || `<${token}>`,
    '<',
    '>'
  );
